import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
*{
    margin:0;
    padding:0;
    box-sizing:border-box;
}

html{
    @media(max-width:1000px){
        font-size:70%;
    }
}

body{
    background:#1b1b1b;
    font-family: 'Open Sans', sans-serif;
}

button{
    font-weight:bold;
    font-size:1.1.rem;
    cursor:pointer;
    padding:1rem 2rem;
    border:3px solid #ef233c;
    background:transparent;
    color:white;
    font-family: 'Open Sans', sans-serif;
    transition: all 0.5s ease;
    &:hover{
        background-color:#ef233c;
        color:white;
    }
    
}

h2{
        font-weight:lighter;
        font-size:3rem;
    }
    h3{
        color:white;
    }
    h4{
        font-weight:bold;
        font-size:2rem;
       
    }
    a{
        font-size:1.1.rem;
    }
    p{
        padding:3rem 0rem;
        color:#ccc;
        font-size: 1.4rem;
        line-height:140%;
    } 

`;

export default GlobalStyle;
